var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKioskPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#EDF9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 16.375H13.875C13.6562 16.375 13.5 16.2188 13.5 16V7.75C13.5 7.5625 13.6562 7.375 13.875 7.375H18.125C18.3125 7.375 18.5 7.5625 18.5 7.75V16C18.5 16.2188 18.3125 16.375 18.125 16.375ZM21 6.375V19.375C21 20.2188 20.3125 20.875 19.5 20.875H12.5C11.6562 20.875 11 20.2188 11 19.375V6.375C11 5.5625 11.6562 4.875 12.5 4.875H19.5C20.3125 4.875 21 5.5625 21 6.375ZM19.5 19.1875V6.5625C19.5 6.46875 19.4062 6.375 19.3125 6.375H12.6875C12.5625 6.375 12.5 6.46875 12.5 6.5625V19.1875C12.5 19.3125 12.5625 19.375 12.6875 19.375H19.3125C19.4062 19.375 19.5 19.3125 19.5 19.1875ZM17.5 18C17.5 18.2188 17.3125 18.375 17.125 18.375H14.875C14.6562 18.375 14.5 18.2188 14.5 18V17.75C14.5 17.5625 14.6562 17.375 14.875 17.375H17.125C17.3125 17.375 17.5 17.5625 17.5 17.75V18Z",
    fill: "#0085E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 27.125C19.7135 27.125 20 26.8571 20 26.4821C20 26.1339 19.7135 25.8393 19.375 25.8393H18.0156V21.9C18.0156 21.6791 17.8366 21.5 17.6157 21.5L17 21.5L15 21.5L14.4 21.5C14.179 21.5 14 21.6791 14 21.9001V25.8393H12.625C12.2604 25.8393 12 26.1339 12 26.4821C12 26.8571 12.2604 27.125 12.625 27.125H19.375Z",
    fill: "#0085E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioskPrimary);
export default __webpack_public_path__ + "static/media/kiosk-primary.cf0f3917.svg";
export { ForwardRef as ReactComponent };